import getExperienceItemsView from 'checkout/selectors/view/itemViews/getExperienceItemsView'
import getTransferItemsView from 'checkout/selectors/view/itemViews/getTransferItemsView'
import { sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getIsEnabledLuxPlusDiscountedExperiences } from '../featureToggle'

export const getAvailableExperienceBenefits = createSelector(
  (state: App.State) => getExperienceItemsView(state),
  (state: App.State) => getTransferItemsView(state),
  (state: App.State) => getIsEnabledLuxPlusDiscountedExperiences(state),
  (experienceView, transferView, isEnabledLuxPlusDiscountedExperiences): App.Checkout.LuxPlusExperienceBenefits => {
    let totalPrice = 0
    let totalBaseMemberPrice = 0
    let totalMemberPrice = 0
    let totalMemberPriceSavings = 0

    if (isEnabledLuxPlusDiscountedExperiences) {
      const totalExperiencePrice = sum(experienceView.data, view => view.totals.price + (view.totals.taxesAndFees ?? 0))
      const totalExperienceBaseMemberPrice = sum(experienceView.data, view => view.totals.memberPrice)
      const totalExperienceMemberPrice = sum(experienceView.data, view => (view.totals.memberPrice || view.totals.price) + (view.totals.taxesAndFees ?? 0))
      const totalExperienceMemberPriceSavings = sum(experienceView.data, view => view.totals.memberPrice > 0 ? view.totals.price - view.totals.memberPrice : 0)

      const totalTransferPrice = sum(transferView.data, view => view.totals.price + (view.totals.taxesAndFees ?? 0))
      const totalTransferBaseMemberPrice = sum(transferView.data, view => view.totals.memberPrice)
      const totalTransferMemberPrice = sum(transferView.data, view => (view.totals.memberPrice || view.totals.price) + (view.totals.taxesAndFees ?? 0))
      const totalTransferMemberPriceSavings = sum(transferView.data, view => view.totals.memberPrice > 0 ? view.totals.price - view.totals.memberPrice : 0)

      totalPrice = totalExperiencePrice + totalTransferPrice
      totalBaseMemberPrice = totalExperienceBaseMemberPrice + totalTransferBaseMemberPrice
      totalMemberPrice = totalExperienceMemberPrice + totalTransferMemberPrice
      totalMemberPriceSavings = totalExperienceMemberPriceSavings + totalTransferMemberPriceSavings
    }

    return {
      totalPrice,
      totalBaseMemberPrice,
      totalMemberPrice,
      totalMemberPriceSavings,
    }
  },
)
